const axios = require("axios");
const {
    join,
    map,
    head,
    defaultTo,
    hasPath,
    find,
    whereEq,
    pipe,
    prop,
    path,
    add,
    mean,
    flip,
    curry,
    isNil,
    ifElse,
    isEmpty,
    lensPath,
    over,
    merge,
    of,
    identity,
    flatten,
} = require("ramda");
const { reduce: lodashreduce, map: lodashmap, size, isArray, keyBy: lodashKeyBy, flattenDeep: lodashFlattenDeep } = require("lodash");
const { from } = require("rxjs");
const { map: rxmap, concatMap, reduce: rxreduce } = require("rxjs/operators");
const util = require("util");
let loreduce = curry((reducerFn, data) => lodashreduce(data, reducerFn));
let lomap = flip(lodashmap);
const lift = ifElse(isArray, identity, of);
const loKeyBy = flip(lodashKeyBy);
const loFlattenDeep = flip(lodashFlattenDeep);
var { getUnixTime, getTime, sub, fromUnixTime, formatISO, toDate } = require("date-fns");
const { zonedTimeToUtc, utcToZonedTime, format, getTimezoneOffset, formatInTimeZone } = require("date-fns-tz");
var moment = require("moment");

const request = async (payload) => {
    let { info, ...rest } = payload;
    try {
        let data = (response) => {
            if (hasPath(["data", "data"], response)) {
                return response.data.data;
            } else {
                return response.data;
            }
        };

        let res = await axios(rest);
        let next = path(["data", "paging", "next"], res);

        if (next) {
            return data(res).concat(await request({ method: "get", url: next }));
        } else {
            return data(res);
        }
    } catch (error) {
        console.log("facebookerror");
        console.log(payload);
        console.log(error.toJSON());
        return [];
        // console.log({ ...error.response.data.error });
    }
};

let access_token =
    "EAAMZAIoNa7KYBAPA1TxDxgTJYewVnvHdhkRuqebakHTWSGhMFZBnMizZCi23NmF10F0R9ZCLFfPgk7SweizVa7YjTfp5D3tc9TaYhKgba7lqwJ3JwCFdt3AD7ZBc5tBXZCca8VYQZAMJMNPTYKQ9FPf5gXbgCZBnDCfqSVoXJSvwtQdRJGpEijKyZAd62RKNOvg1MqMlWL1ROy4DG5rsHRqZCEr0MZCZBZC7HQJZBWm2b7ZCvwrhAZDZD";

const User = (params) => {
    let { access_token } = params;

    const profile = {
        get: async (params) => {
            let user_fields = [
                "id",
                "about",
                "age_range",
                "birthday",
                "education",
                "email",
                "favorite_athletes",
                "favorite_teams",
                "first_name",
                "gender",
                "hometown",
                "inspirational_people",
                "installed",
                "is_guest_user",
                "languages",
                "last_name",
                "link",
                "location",
                "meeting_for",
                "middle_name",
                "name",
                "name_format",
                "political",
                "quotes",
                "relationship_status",
                "significant_other",
                "sports",
                "supports_donate_button_in_live_video",
                "token_for_business",
                "video_upload_limits",
                "website",
            ];

            let url = `https://graph.facebook.com/v12.0/me`;

            let payload = {
                method: "get",
                url,
                params: {
                    access_token,
                    fields: join(",", user_fields),
                    limit: 50,
                },
            };

            let response = await request(payload);

            return {
                type: "object",
                data: { ...response },
            };
        },
    };

    const profile_picture = {
        get: async (params) => {
            let { fb_user_id } = params;

            let picture_url = `https://graph.facebook.com/v12.0/${fb_user_id}/picture`;

            let payload = {
                method: "get",
                url: picture_url,
                params: {
                    access_token,
                    redirect: false,
                },
            };

            let response = await request(payload);

            let { url: profile_picture_url } = response;

            return {
                type: "object",
                data: { profile_picture_url },
            };
        },
    };

    const ad_accounts = {
        get: async (params) => {
            let func_name = "User:ad_accounts:get";
            console.log(func_name);

            let { fb_user_id } = params;

            let adaccount_fields = [
                "id",
                "account_id",
                "account_status",
                "age",
                "agency_client_declaration",
                "amount_spent",
                "attribution_spec",
                "balance",
                "business",
                "business_city",
                "business_country_code",
                "business_name",
                "business_state",
                "business_street",
                "business_street2",
                "business_zip",
                "can_create_brand_lift_study",
                "created_time",
                "currency",
                "disable_reason",
                "end_advertiser",
                "end_advertiser_name",
                "extended_credit_invoice_group",
                "failed_delivery_checks",
                "fb_entity",
                // "funding_source_details",
                "has_advertiser_opted_in_odax",
                "has_migrated_permissions",
                "io_number",
                "is_attribution_spec_system_default",
                "is_direct_deals_enabled",
                "is_notifications_enabled",
                "is_personal",
                "is_prepay_account",
                "is_tax_id_required",
                "line_numbers",
                "media_agency",
                "min_campaign_group_spend_cap",
                "min_daily_budget",
                "name",
                "offsite_pixels_tos_accepted",
                "owner",
                "partner",
                "spend_cap",
                "tax_id",
                "tax_id_status",
                "tax_id_type",
                "timezone_id",
                "timezone_name",
                "timezone_offset_hours_utc",
                "tos_accepted",
                "user_tasks",
                "user_tos_accepted",
            ];

            let url = `https://graph.facebook.com/v12.0/${fb_user_id}/adaccounts`;

            let payload = {
                method: "get",
                url,
                params: {
                    access_token,
                    fields: join(",", adaccount_fields),
                    limit: 50,
                },
            };

            let ad_accounts_response = await request(payload);

            return {
                type: "object",
                data: ad_accounts_response,
            };
        },
    };

    return {
        ad_accounts,
        profile,
        profile_picture,
    };
};

const Account = (params) => {
    let { account_id, access_token } = params;

    const to_path = (path, data) => {
        let lens_path = map((p) => {
            if (p.includes("*")) {
                let property = p.substring(1);
                return data[property];
            } else {
                return p;
            }
        }, path);
        return lens_path;
    };

    const metrics = (insight) => {
        let value = (data) => prop("value", data);
        let actions = (action_type) => pipe(prop("actions"), ifElse(isNil, identity, find(whereEq({ action_type }))))(insight);
        let actions_values = (action_type) => pipe(prop("action_values"), ifElse(isNil, identity, find(whereEq({ action_type }))))(insight);

        let fbspend = defaultTo(0, Number(prop("spend", insight)));
        let fbroas = defaultTo(0, Number(path(["purchase_roas", 0, "value"], insight)));
        let fbclicks = defaultTo(0, Number(value(actions("link_click"))));
        let fbsales = defaultTo(0, Number(value(actions("offsite_conversion.fb_pixel_purchase"))));
        let fbleads = defaultTo(0, Number(value(actions("offsite_conversion.fb_pixel_lead"))));
        let fbmade = defaultTo(0, Number(value(actions_values("offsite_conversion.fb_pixel_purchase"))));

        let result = {
            fbclicks,
            fbspend,
            fbmade,
            fbsales,
            fbroas,
            fbleads,
        };

        return result;
    };

    const stats = pipe(
        map(metrics),
        loreduce((prev, curr) => ({
            clicks: add(prev.clicks, curr.clicks),
            spend: add(prev.spend, curr.spend),
            made: add(prev.made, curr.made),
            sales: add(prev.sales, curr.sales),
            roas: mean([prev.roas, curr.roas]),
            leads: add(prev.leads, curr.leads),
        }))
    );

    const utilities = {
        is_abo: (adset) => {
            return adset.daily_budget ? true : false;
        },

        is_cbo: (campaign) => {
            // console.log("utilities:is_cbo");
            // console.log(campaign.daily_budget);
            // console.log(campaign);
            return campaign.daily_budget ? true : false;
        },
    };

    const campaign_insights = {
        get: async (params) => {
            let campaign_insights_fields = [
                "account_id",
                "account_name",
                "action_values",
                "actions",
                "ad_click_actions",
                "ad_id",
                "ad_impression_actions",
                "ad_name",
                "adset_id",
                "adset_name",
                "age_targeting",
                "attribution_setting",
                "auction_bid",
                "auction_competitiveness",
                "auction_max_competitor_bid",
                "buying_type",
                "campaign_id",
                "campaign_name",
                "canvas_avg_view_percent",
                "canvas_avg_view_time",
                "catalog_segment_actions",
                "catalog_segment_value",
                "catalog_segment_value_mobile_purchase_roas",
                "catalog_segment_value_omni_purchase_roas",
                "catalog_segment_value_website_purchase_roas",
                "clicks",
                "conversion_values",
                "conversions",
                "converted_product_quantity",
                "converted_product_value",
                "cost_per_15_sec_video_view",
                "cost_per_2_sec_continuous_video_view",
                "cost_per_action_type",
                "cost_per_ad_click",
                "cost_per_conversion",
                "cost_per_dda_countby_convs",
                "cost_per_inline_link_click",
                "cost_per_inline_post_engagement",
                "cost_per_one_thousand_ad_impression",
                "cost_per_outbound_click",
                "cost_per_thruplay",
                "cost_per_unique_action_type",
                "cost_per_unique_click",
                "cost_per_unique_inline_link_click",
                "cost_per_unique_outbound_click",
                "cpc",
                "cpm",
                "cpp",
                "created_time",
                "ctr",
                "date_start",
                "date_stop",
                "dda_countby_convs",
                "dda_results",
                "estimated_ad_recall_rate_lower_bound",
                "estimated_ad_recall_rate_upper_bound",
                "estimated_ad_recallers_lower_bound",
                "estimated_ad_recallers_upper_bound",
                "frequency",
                "full_view_impressions",
                "full_view_reach",
                "gender_targeting",
                "impressions",
                "inline_link_click_ctr",
                "inline_link_clicks",
                "inline_post_engagement",
                "instant_experience_clicks_to_open",
                "instant_experience_clicks_to_start",
                "instant_experience_outbound_clicks",
                "interactive_component_tap",
                "labels",
                "location",
                "mobile_app_purchase_roas",
                "objective",
                "optimization_goal",
                "outbound_clicks",
                "outbound_clicks_ctr",
                "purchase_roas",
                "qualifying_question_qualify_answer_rate",
                "reach",
                "social_spend",
                "spend",
                "updated_time",
                "video_15_sec_watched_actions",
                "video_30_sec_watched_actions",
                "video_avg_time_watched_actions",
                "video_continuous_2_sec_watched_actions",
                "video_p100_watched_actions",
                "video_p25_watched_actions",
                "video_p50_watched_actions",
                "video_p75_watched_actions",
                "video_p95_watched_actions",
                "video_play_actions",
                "video_play_curve_actions",
                "video_play_retention_0_to_15s_actions",
                "video_play_retention_20_to_60s_actions",
                "video_play_retention_graph_actions",
                "video_time_watched_actions",
                "website_ctr",
                "website_purchase_roas",
                "wish_bid",
            ];

            let { campaign_id, time_range } = params;
            let { since, until } = time_range;
            let url = `https://graph.facebook.com/v12.0/${campaign_id}/insights`;

            let payload = {
                method: "get",
                url,
                params: {
                    access_token,
                    time_range,
                    fields: join(",", campaign_insights_fields),
                },
            };

            let insights = await request(payload);
            return { type: "object", data: { campaign_id, insights, stats: stats(insights) } };
        },
    };

    const campaign = {
        get: async (params) => {
            console.log("campaign:get");

            let campaign_fields = [
                "id",
                "account_id",
                "adlabels",
                "bid_strategy",
                "budget_remaining",
                "buying_type",
                "can_use_spend_cap",
                "configured_status",
                "created_time",
                "daily_budget",
                "effective_status",
                "is_skadnetwork_attribution",
                "issues_info",
                "last_budget_toggling_time",
                "lifetime_budget",
                "name",
                "objective",
                "pacing_type",
                "promoted_object",
                "recommendations",
                "smart_promotion_type",
                "source_campaign",
                "source_campaign_id",
                "special_ad_categories",
                "special_ad_category",
                "special_ad_category_country",
                "spend_cap",
                "start_time",
                "status",
                "stop_time",
                "topline_id",
                "updated_time",

                "boosted_object_id",
                "brand_lift_studies",
                "budget_rebalance_flag",
            ];

            let { campaign_id, time_range } = params;
            let { since, until } = time_range;
            let url = `https://graph.facebook.com/v12.0/${campaign_id}`;

            let payload = {
                info: { endpoint: "get", asset_type: "campaign", campaign_id },
                method: "get",
                url,
                params: {
                    access_token,
                    time_range,
                    fields: join(",", campaign_fields),
                },
            };

            let campaign = await request(payload);
            // console.log(campaign);

            return {
                type: "object",
                data: { campaign_id, ...campaign },
            };
        },

        start: async (params) => {
            console.log("campaign:start");
            console.log(params);

            let { campaign_id, status } = params;

            let url = `https://graph.facebook.com/v12.0/${campaign_id}`;

            let payload = {
                method: "post",
                url,
                params: {
                    access_token,
                    status,
                },
            };

            let campaign = await request(payload);

            console.log("campaign:start:result");
            console.log(campaign);

            return {
                type: "object",
                data: { campaign_id, ...campaign },
            };
        },

        stop: async (params) => {
            console.log("campaign:stop");
            console.log(params);

            let { campaign_id, status } = params;

            let url = `https://graph.facebook.com/v12.0/${campaign_id}`;

            let payload = {
                method: "post",
                url,
                params: {
                    access_token,
                    status,
                },
            };

            // let campaign = await request(payload);

            // console.log("campaign:stop:result");
            // console.log(campaign);

            return {
                type: "object",
                data: { campaign_id, prev_value: "active", updated_value: "paused" },
            };
        },

        delete: async (params) => {
            console.log("campaign:delete");
            console.log(params);

            let { campaign_id } = params;

            let url = `https://graph.facebook.com/v12.0/${campaign_id}`;

            let payload = {
                method: "delete",
                url,
                params: {
                    access_token,
                },
            };

            let campaign = await request(payload);

            console.log("campaign:delete:result");
            console.log(campaign);

            return {
                type: "object",
                data: { campaign_id, ...campaign },
            };
        },

        set_budget: async (params) => {
            // console.log("campaign:set_budget");

            let { campaign_id, value } = params;
            let daily_budget = Number(value) * 100;

            let url = `https://graph.facebook.com/v12.0/${campaign_id}`;

            let payload = {
                method: "post",
                url,
                params: {
                    access_token,
                    daily_budget,
                },
            };

            let result = await request(payload);

            return {
                type: "object",
                data: { campaign_id, ...result },
            };
        },

        increase_budget: async (params) => {
            console.log("campaign:increase_budget");

            let { campaign_id, type, value, spend_cap, lifetime_budget, time_range } = params;
            let { since, until } = time_range;

            let url = `https://graph.facebook.com/v12.0/${campaign_id}`;

            let account = Account({ account_id, access_token });

            let campaign = await account.get({
                campaign: {
                    path: [],
                    params: {
                        time_range: { since, until },
                        campaign_id,
                    },
                },
            });

            if (account.utilities.is_cbo(campaign)) {
                if (type == "percent") {
                    let { daily_budget } = campaign;
                    let increase_amount = (Number(value) / 100) * Number(daily_budget);
                    let new_daily_budget = parseInt(Number(daily_budget) + increase_amount);

                    console.log("campaigns:increase_budget:percent");
                    console.log(access_token);
                    console.log(campaign);
                    console.log(campaign_id);
                    console.log(daily_budget);
                    console.log(increase_amount);
                    console.log(new_daily_budget);

                    let payload = {
                        info: { endpoint: "increase_budget", type: "percent", asset_type: "campaign" },
                        method: "post",
                        url,
                        params: {
                            access_token,
                            daily_budget: new_daily_budget,
                        },
                    };

                    let result = await request(payload);

                    return {
                        type: "object",
                        data: { campaign_id, prev_value: daily_budget / 100, updated_value: new_daily_budget / 100 },
                    };
                }

                if (type == "amount") {
                    console.log("updating_campaign_value");
                    let { daily_budget } = campaign;
                    let increase_amount = Number(value) * 100;
                    let new_daily_budget = parseInt(Number(daily_budget) + increase_amount);

                    let payload = {
                        info: { endpoint: "increase_budget", type: "amount", asset_type: "campaign" },
                        method: "post",
                        url,
                        params: {
                            access_token,
                            daily_budget: new_daily_budget,
                        },
                    };

                    let result = await request(payload);

                    return {
                        type: "object",
                        data: { campaign_id, prev_value: daily_budget / 100, updated_value: new_daily_budget / 100 },
                    };
                }
            } else {
                return {
                    type: "object",
                    data: {},
                };
            }
        },

        decrease_budget: async (params) => {
            console.log("campaign:decrease_budget");

            let { campaign_id, type, value, spend_cap, lifetime_budget, time_range } = params;
            let { since, until } = time_range;

            let url = `https://graph.facebook.com/v12.0/${campaign_id}`;

            let account = Account({ account_id, access_token });

            let campaign = await account.get({
                campaign: {
                    path: [],
                    params: {
                        time_range: { since, until },
                        campaign_id,
                    },
                },
            });

            if (account.utilities.is_cbo(campaign)) {
                if (type == "percent") {
                    let { daily_budget } = campaign;
                    let decrease_amount = (Number(value) / 100) * Number(daily_budget);
                    let new_daily_budget = Number(daily_budget) - decrease_amount;

                    let payload = {
                        info: { endpoint: "decrease_budget", type: "percent", asset_type: "campaign" },
                        method: "post",
                        url,
                        params: {
                            access_token,
                            daily_budget: new_daily_budget,
                        },
                    };

                    let result = await request(payload);
                    // console.log(result);

                    return {
                        type: "object",
                        data: { campaign_id, prev_value: daily_budget / 100, updated_value: new_daily_budget / 100 },
                    };
                }

                if (type == "amount") {
                    let { daily_budget } = campaign;
                    let decrease_amount = Number(value) * 100;
                    let new_daily_budget = Number(daily_budget) - decrease_amount;

                    let payload = {
                        info: { endpoint: "decrease_budget", type: "amount", asset_type: "campaign" },
                        method: "post",
                        url,
                        params: {
                            access_token,
                            daily_budget: new_daily_budget,
                        },
                    };

                    let result = await request(payload);
                    console.log(result);

                    return {
                        type: "object",
                        data: { campaign_id, prev_value: daily_budget / 100, updated_value: new_daily_budget / 100 },
                    };
                }
            } else {
                return {
                    type: "object",
                    data: {},
                };
            }
        },
    };

    const campaigns = {
        get: async (params) => {
            let { time_range, limit, effective_status = [] } = params;
            let { since, until } = time_range;

            let campaigns_fields = ["id", "name"];
            let campaigns_url = `https://graph.facebook.com/v12.0/act_${account_id}/campaigns`;
            let limit_default = defaultTo(500);

            let payload = {
                method: "get",
                url: campaigns_url,
                params: {
                    access_token,
                    time_range,
                    limit: limit_default(limit),
                    effective_status,
                    fields: join(",", campaigns_fields),
                },
            };

            let result = await request(payload);

            // console.log("campaigns.get");
            // console.log(result);

            return { type: "array", data: map((campaign_value) => ({ ...campaign_value, campaign_id: campaign_value.id }), result) };
        },
    };

    const adset_insights = {
        get: async (params) => {
            let adset_insights_fields = [
                "account_currency",
                "account_id",
                "account_name",
                "action_values",
                "actions",
                "ad_click_actions",
                "ad_id",
                "ad_impression_actions",
                "ad_name",
                "adset_id",
                "adset_name",
                "age_targeting",
                "attribution_setting",
                "auction_bid",
                "auction_competitiveness",
                "auction_max_competitor_bid",
                "buying_type",
                "campaign_id",
                "campaign_name",
                "canvas_avg_view_percent",
                "canvas_avg_view_time",
                "catalog_segment_actions",
                "catalog_segment_value",
                "catalog_segment_value_mobile_purchase_roas",
                "catalog_segment_value_omni_purchase_roas",
                "catalog_segment_value_website_purchase_roas",
                "clicks",
                "conversion_values",
                "conversions",
                "converted_product_quantity",
                "converted_product_value",
                "cost_per_15_sec_video_view",
                "cost_per_2_sec_continuous_video_view",
                "cost_per_action_type",
                "cost_per_ad_click",
                "cost_per_conversion",
                "cost_per_dda_countby_convs",
                "cost_per_inline_link_click",
                "cost_per_inline_post_engagement",
                "cost_per_one_thousand_ad_impression",
                "cost_per_outbound_click",
                "cost_per_thruplay",
                "cost_per_unique_action_type",
                "cost_per_unique_click",
                "cost_per_unique_inline_link_click",
                "cost_per_unique_outbound_click",
                "cpc",
                "cpm",
                "cpp",
                "created_time",
                "ctr",
                "date_start",
                "date_stop",
                "dda_countby_convs",
                "dda_results",
                "estimated_ad_recall_rate_lower_bound",
                "estimated_ad_recall_rate_upper_bound",
                "estimated_ad_recallers_lower_bound",
                "estimated_ad_recallers_upper_bound",
                "frequency",
                "full_view_impressions",
                "full_view_reach",
                "gender_targeting",
                "impressions",
                "inline_link_click_ctr",
                "inline_link_clicks",
                "inline_post_engagement",
                "instant_experience_clicks_to_open",
                "instant_experience_clicks_to_start",
                "instant_experience_outbound_clicks",
                "interactive_component_tap",
                "labels",
                "location",
                "mobile_app_purchase_roas",
                "objective",
                "optimization_goal",
                "outbound_clicks",
                "outbound_clicks_ctr",
                "place_page_name",
                "purchase_roas",
                "qualifying_question_qualify_answer_rate",
                "reach",
                "social_spend",
                "spend",
                "updated_time",
                "video_15_sec_watched_actions",
                "video_30_sec_watched_actions",
                "video_avg_time_watched_actions",
                "video_continuous_2_sec_watched_actions",
                "video_p100_watched_actions",
                "video_p25_watched_actions",
                "video_p50_watched_actions",
                "video_p75_watched_actions",
                "video_p95_watched_actions",
                "video_play_actions",
                "video_play_curve_actions",
                "video_play_retention_0_to_15s_actions",
                "video_play_retention_20_to_60s_actions",
                "video_play_retention_graph_actions",
                "video_time_watched_actions",
                "website_ctr",
                "website_purchase_roas",
            ];

            let { adset_id, time_range } = params;
            let { since, until } = time_range;
            let url = `https://graph.facebook.com/v12.0/${adset_id}/insights`;

            let payload = {
                method: "get",
                url,
                params: {
                    access_token,
                    time_range,
                    fields: join(",", adset_insights_fields),
                },
            };

            let insights = await request(payload);
            return { type: "object", data: { adset_id, insights, stats: stats(insights) } };
        },
    };

    const adset = {
        get: async (params) => {
            // console.log("adset");
            // console.log(params);
            let { adset_id, time_range } = params;
            let { since, until } = time_range;

            let adset_fields = [
                "id",
                "name",
                "campaign_id",
                "account_id",
                "adlabels",
                "adset_schedule",
                "asset_feed_id",
                "attribution_spec",
                "bid_adjustments",
                "bid_amount",
                "bid_constraints",
                "bid_info",
                "bid_strategy",
                "billing_event",
                "budget_remaining",
                "campaign",
                "configured_status",
                "created_time",
                "creative_sequence",
                "daily_budget",
                "daily_min_spend_target",
                "daily_spend_cap",
                "destination_type",
                "effective_status",
                "end_time",
                "frequency_control_specs",
                "instagram_actor_id",
                "is_dynamic_creative",
                "issues_info",
                "learning_stage_info",
                "lifetime_budget",
                "lifetime_imps",
                "lifetime_min_spend_target",
                "lifetime_spend_cap",
                "multi_optimization_goal_weight",
                "optimization_goal",
                "optimization_sub_event",
                "pacing_type",
                "promoted_object",
                "recommendations",
                "recurring_budget_semantics",
                "review_feedback",
                "rf_prediction_id",
                "source_adset",
                "source_adset_id",
                "start_time",
                "status",
                "targeting",
                "targeting_optimization_types",
                "time_based_ad_rotation_id_blocks",
                "time_based_ad_rotation_intervals",
                "updated_time",
                "use_new_app_click",
            ];

            let url = `https://graph.facebook.com/v12.0/${adset_id}`;

            let payload = {
                info: { endpoint: "get", asset_type: "adset", adset_id },
                method: "get",
                url,
                params: {
                    access_token,
                    time_range,
                    fields: join(",", adset_fields),
                },
            };

            try {
                let result = await request(payload);

                return {
                    type: "object",
                    data: { adset_id, ...result },
                };
            } catch (error) {
                // console.log("errorrrrrr");
                return;
            }
        },

        start: async (params) => {
            // console.log("adset:start");
            // console.log(params);

            let { adset_id, status } = params;

            let url = `https://graph.facebook.com/v12.0/${adset_id}`;

            let payload = {
                method: "post",
                url,
                params: {
                    access_token,
                    status,
                },
            };

            let adset = await request(payload);

            // console.log("adset:start:result");
            // console.log(adset);

            return {
                type: "object",
                data: { adset_id, ...adset },
            };
        },

        stop: async (params) => {
            console.log("adset:stop");
            // console.log(params);

            let { adset_id, status } = params;

            let url = `https://graph.facebook.com/v12.0/${adset_id}`;

            let payload = {
                info: { endpoint: "stop", asset_type: "adset" },
                method: "post",
                url,
                params: {
                    access_token,
                    status,
                },
            };

            let adset = await request(payload);

            // console.log("adset:start:result");
            // console.log(adset);

            return {
                type: "object",
                data: { adset_id, prev_value: "active", updated_value: "paused" },
            };
        },

        delete: async (params) => {
            console.log("adset:delete");
            // console.log(params);

            let { adset_id } = params;

            let url = `https://graph.facebook.com/v12.0/${adset_id}`;

            let payload = {
                method: "delete",
                url,
                params: {
                    access_token,
                },
            };

            let adset = await request(payload);

            // console.log("adset:delete:result");
            // console.log(adset);

            return {
                type: "object",
                data: { adset_id, ...adset, prev_value: adset.effective_status, updated_value: "deleted" },
            };
        },

        set_budget: async (params) => {
            // console.log("adset:set_budget");

            let { adset_id, value } = params;
            let daily_budget = Number(value) * 100;

            let url = `https://graph.facebook.com/v12.0/${adset_id}`;

            let payload = {
                method: "post",
                url,
                params: {
                    access_token,
                    daily_budget,
                },
            };

            let result = await request(payload);

            return {
                type: "object",
                data: { adset_id, ...result },
            };
        },

        increase_budget: async (params) => {
            console.log("adset:increase_budget");

            let { adset_id, type, value, time_range } = params;
            let { since, until } = time_range;

            let url = `https://graph.facebook.com/v12.0/${adset_id}`;

            let account = Account({ account_id, access_token });

            let adset = await account.get({
                adset: {
                    path: [],
                    params: {
                        time_range: { since, until },
                        adset_id,
                    },
                },
            });

            if (account.utilities.is_abo(adset)) {
                if (type == "percent") {
                    let { daily_budget } = adset;
                    let increase_amount = (Number(value) / 100) * Number(daily_budget);
                    let new_daily_budget = parseInt(Number(daily_budget) + increase_amount);

                    // console.log("adset:increase_budget:percent");
                    // console.log(access_token);
                    // console.log(adset);
                    // console.log(adset_id);
                    // console.log(daily_budget);
                    // console.log(increase_amount);
                    // console.log(new_daily_budget);

                    let payload = {
                        info: { endpoint: "increase_budget", type: "percent", asset_type: "adset" },
                        method: "post",
                        url,
                        params: {
                            access_token,
                            daily_budget: new_daily_budget,
                        },
                    };

                    let result = await request(payload);

                    return {
                        type: "object",
                        data: { adset_id, prev_value: daily_budget / 100, updated_value: new_daily_budget / 100 },
                    };
                }

                if (type == "amount") {
                    let { daily_budget } = adset;
                    let increase_amount = Number(value) * 100;
                    let new_daily_budget = parseInt(Number(daily_budget) + increase_amount);

                    let payload = {
                        info: { endpoint: "increase_budget", type: "amount", asset_type: "adset" },
                        method: "post",
                        url,
                        params: {
                            access_token,
                            daily_budget: new_daily_budget,
                        },
                    };

                    let result = await request(payload);

                    return {
                        type: "object",
                        data: { adset_id, prev_value: daily_budget / 100, updated_value: new_daily_budget / 100 },
                    };
                }
            } else {
                return {
                    type: "object",
                    data: {},
                };
            }
        },

        decrease_budget: async (params) => {
            // console.log("adset:decrease_budget");

            let { adset_id, type, value, time_range } = params;
            let { since, until } = time_range;

            let url = `https://graph.facebook.com/v12.0/${adset_id}`;

            let account = Account({ account_id, access_token });

            let adset = await account.get({
                adset: {
                    path: [],
                    params: {
                        time_range: { since, until },
                        adset_id,
                    },
                },
            });

            if (account.utilities.is_abo(adset)) {
                if (type == "percent") {
                    let { daily_budget } = adset;
                    let decrease_amount = (Number(value) / 100) * Number(daily_budget);
                    let new_daily_budget = parseInt(Number(daily_budget) - decrease_amount);

                    let payload = {
                        info: { endpoint: "decrease_budget", type: "percent", asset_type: "adset" },
                        endpoint: "decrease_budget",
                        method: "post",
                        url,
                        params: {
                            access_token,
                            daily_budget: new_daily_budget,
                        },
                    };

                    let result = await request(payload);

                    return {
                        type: "object",
                        data: { adset_id, prev_value: daily_budget / 100, updated_value: new_daily_budget / 100 },
                    };
                }

                if (type == "amount") {
                    let { daily_budget } = adset;
                    let decrease_amount = Number(value) * 100;
                    let new_daily_budget = parseInt(Number(daily_budget) - decrease_amount);

                    let payload = {
                        info: { endpoint: "decrease_budget", type: "amount", asset_type: "adset" },
                        method: "post",
                        url,
                        params: {
                            access_token,
                            daily_budget: new_daily_budget,
                        },
                    };

                    let result = await request(payload);

                    return {
                        type: "object",
                        data: { adset_id, prev_value: daily_budget / 100, updated_value: new_daily_budget / 100 },
                    };
                }
            } else {
                return {
                    type: "object",
                    data: {},
                };
            }
        },
    };

    const adsets = {
        get: async (params) => {
            let { campaign_id, time_range, limit, effective_status = [] } = params;
            let { since, until } = time_range;

            let adsets_fields = ["id", "name", "campaign_id"];
            let url = `https://graph.facebook.com/v12.0/${campaign_id}/adsets`;
            let limit_default = defaultTo(500);

            let payload = {
                method: "get",
                url,
                params: {
                    access_token,
                    time_range,
                    limit: limit_default(limit),
                    effective_status,
                    fields: join(",", adsets_fields),
                },
            };

            let result = await request(payload);
            return { type: "array", data: map((adset_value) => ({ ...adset_value, adset_id: adset_value.id }), result) };
        },
    };

    const ad_insights = {
        get: async (params) => {
            let ad_insights_fields = [
                "account_currency",
                "account_id",
                "account_name",
                "action_values",
                "actions",
                "ad_click_actions",
                "ad_id",
                "ad_impression_actions",
                "ad_name",
                "adset_id",
                "adset_name",
                "age_targeting",
                "attribution_setting",
                "auction_bid",
                "auction_competitiveness",
                "auction_max_competitor_bid",
                "buying_type",
                "campaign_id",
                "campaign_name",
                "canvas_avg_view_percent",
                "canvas_avg_view_time",
                "catalog_segment_actions",
                "catalog_segment_value",
                "catalog_segment_value_mobile_purchase_roas",
                "catalog_segment_value_omni_purchase_roas",
                "catalog_segment_value_website_purchase_roas",
                "clicks",
                "conversion_values",
                "conversions",
                "converted_product_quantity",
                "converted_product_value",
                "cost_per_15_sec_video_view",
                "cost_per_2_sec_continuous_video_view",
                "cost_per_action_type",
                "cost_per_ad_click",
                "cost_per_conversion",
                "cost_per_dda_countby_convs",
                "cost_per_inline_link_click",
                "cost_per_inline_post_engagement",
                "cost_per_one_thousand_ad_impression",
                "cost_per_outbound_click",
                "cost_per_thruplay",
                "cost_per_unique_action_type",
                "cost_per_unique_click",
                // "cost_per_unique_conversion",
                "cost_per_unique_inline_link_click",
                "cost_per_unique_outbound_click",
                "cpc",
                "cpm",
                "cpp",
                "ctr",
                "date_start",
                "date_stop",
                "dda_countby_convs",
                "dda_results",
                "estimated_ad_recall_rate_lower_bound",
                "estimated_ad_recall_rate_upper_bound",
                "estimated_ad_recallers_lower_bound",
                "estimated_ad_recallers_upper_bound",
                "frequency",
                "full_view_impressions",
                "full_view_reach",
                "gender_targeting",
                "impressions",
                "inline_link_click_ctr",
                "inline_link_clicks",
                "inline_post_engagement",
                "instant_experience_clicks_to_open",
                "instant_experience_clicks_to_start",
                "instant_experience_outbound_clicks",
                "interactive_component_tap",
                "labels",
                "location",
                "mobile_app_purchase_roas",
                "objective",
                "optimization_goal",
                "outbound_clicks",
                "outbound_clicks_ctr",
                "place_page_name",
                "purchase_roas",
                "qualifying_question_qualify_answer_rate",
                "reach",
                "social_spend",
                "spend",
                "updated_time",
                "video_15_sec_watched_actions",
                "video_30_sec_watched_actions",
                "video_avg_time_watched_actions",
                "video_continuous_2_sec_watched_actions",
                "video_p100_watched_actions",
                "video_p25_watched_actions",
                "video_p50_watched_actions",
                "video_p75_watched_actions",
                "video_p95_watched_actions",
                "video_play_actions",
                "video_play_curve_actions",
                "video_play_retention_0_to_15s_actions",
                "video_play_retention_20_to_60s_actions",
                "video_play_retention_graph_actions",
                "video_time_watched_actions",
                "website_ctr",
                "website_purchase_roas",
                "wish_bid",
            ];

            let { ad_id, time_range } = params;
            let { since, until } = time_range;
            let url = `https://graph.facebook.com/v12.0/${ad_id}/insights`;

            let payload = {
                method: "get",
                url,
                params: {
                    access_token,
                    time_range,
                    fields: join(",", ad_insights_fields),
                },
            };

            let insights = await request(payload);
            return { type: "object", data: { ad_id, insights, stats: stats(insights) } };
        },
    };

    const ad = {
        get: async (params) => {
            // console.log("adset");
            // console.log(params);
            let { ad_id, time_range } = params;
            let { since, until } = time_range;

            let ad_fields = [
                "id",
                "name",
                "campaign_id",
                "adset_id",
                "account_id",
                "ad_review_feedback",
                "adlabels",
                "adset",
                "bid_amount",
                "campaign",
                "configured_status",
                "conversion_domain",
                "created_time",
                "creative",
                "effective_status",
                "issues_info",
                "last_updated_by_app_id",
                "preview_shareable_link",
                "recommendations",
                "source_ad",
                "source_ad_id",
                "status",
                "tracking_specs",
                "updated_time",
            ];

            let url = `https://graph.facebook.com/v12.0/${ad_id}`;

            let payload = {
                method: "get",
                url,
                params: {
                    access_token,
                    time_range,
                    fields: join(",", ad_fields),
                },
            };

            try {
                let result = await request(payload);

                return {
                    type: "object",
                    data: { ad_id, ...result },
                };
            } catch (error) {
                // console.log("errorrrrrr");
                return;
            }
        },
    };

    const ads = {
        get: async (params) => {
            let { adset_id, time_range, limit, effective_status = [] } = params;
            let { since, until } = time_range;

            let ads_fields = ["id", "name", "adset_id"];
            let url = `https://graph.facebook.com/v12.0/${adset_id}/ads`;
            let limit_default = defaultTo(500);

            let payload = {
                method: "get",
                url,
                params: {
                    access_token,
                    time_range,
                    limit: limit_default(limit),
                    effective_status,
                    fields: join(",", ads_fields),
                },
            };

            let result = await request(payload);
            return { type: "array", data: map((ad_value) => ({ ...ad_value, ad_id: ad_value.id }), result) };
        },
    };

    const get = async (spec) => {
        let payload = {};

        let resolve_spec = async (spec, prev) =>
            Promise.all(
                lomap(async (value, key) => {
                    let { params, path, ...next } = value;
                    let result;

                    if (!prev) {
                        result = await api[key]["get"](params);

                        if (result.type == "array") {
                            map((val) => {
                                payload = over(lensPath(to_path(path, val)), merge(val), payload);
                            }, result.data);
                        }

                        if (result.type == "object") {
                            payload = over(lensPath(to_path(path, result.data)), merge(result.data), payload);
                        }
                    } else {
                        if (prev.type == "object") {
                            result = await api[key]["get"]({ ...prev.data, ...params });

                            if (result.type == "array") {
                                map((val) => {
                                    payload = over(lensPath(to_path(path, val)), merge(val), payload);
                                }, result.data);
                            }

                            if (result.type == "object") {
                                payload = over(lensPath(to_path(path, result.data)), merge(result.data), payload);
                            }
                        }

                        if (prev.type == "array") {
                            result = await Promise.all(map((child) => api[key]["get"]({ ...child, ...params }), prev.data));
                            result = map((res) => res.data, result);
                            result = { type: "array", data: flatten(result) };

                            map((val) => {
                                payload = over(lensPath(to_path(path, val)), merge(val), payload);
                            }, result.data);
                        }
                    }

                    if (!isEmpty(next)) {
                        if (size(next) > 1) {
                            await Promise.all(lomap(async (value, key) => await resolve_spec({ [key]: value }, result), next));
                        } else {
                            await resolve_spec(next, result);
                        }
                    } else {
                        return result;
                    }
                }, spec)
            );

        await resolve_spec(spec);
        return payload;
    };

    const post = async (spec) => {
        console.log("post");
        return await Promise.all(
            lomap(async (spec, endpoint) => {
                let { params } = spec;
                let { action } = params;

                return await api[endpoint][action](params);
            }, spec)
        );
    };

    let api = {
        campaigns,
        campaign,
        campaign_insights,
        adsets,
        adset,
        adset_insights,
        ads,
        ad,
        ad_insights,
    };

    return {
        account_id,
        utilities,
        get,
        post,
    };
};

let account_id = "1560519410661307";

Account({ account_id }).get({
    // ads: {
    //     path: ["*ad_id"],
    //     params: { time_range: { since: "2021-12-01", until: "2021-12-01" }, adset_id: "23848603912180006" },
    //     ad: {
    //         path: ["*ad_id"],
    //         params: { time_range: { since: "2021-12-01", until: "2021-12-01" } },
    //     },
    // },
    // ad_insights: {
    //     path: ["*ad_id"],
    //     params: { time_range: { since: "2021-12-01", until: "2021-12-01" }, ad_id: "23849547155750006" },
    // },
    // adset_insights: {
    //     path: ["adset", "*adset_id"],
    //     params: { time_range: { since: "2021-12-01", until: "2021-12-01" }, adset_id: "23848603912180006" },
    // },
    // adset: {
    //     path: ["adset", "*adset_id"],
    //     params: { time_range: { since: "2021-12-01", until: "2021-12-01" }, adset_id: "23848603912180006" },
    //     adset_insights: {
    //         path: ["adset", "*adset_id"],
    //         params: { time_range: { since: "2021-12-01", until: "2021-12-01" }, adset_id: "23848603912180006" },
    //     },
    // },
    // campaign: {
    //     path: ["campaign", "*campaign_id"],
    //     params: {
    //         time_range: { since: "2021-01-01", until: "2021-01-01" },
    //         campaign_id: "23849577813970006",
    //     },
    // },
    // adsets: {
    //     path: ["campaign", "*campaign_id", "adsets", "*adset_id"],
    //     params: { time_range: { since: "2021-12-01", until: "2021-12-01" }, effective_status: ["ACTIVE"] },
    //     adset: {
    //         path: ["campaign", "*campaign_id", "adsets", "*adset_id"],
    //         params: { time_range: { since: "2021-12-01", until: "2021-12-01" } },
    //     },
    // },
    // adsets: {
    //     path: ["adsets", "*adset_id"],
    //     params: { time_range: { since: "2021-12-01", until: "2021-12-01" }, effective_status: ["ACTIVE"], campaign_id: "23848052102840006" },
    //     adset: {
    //         path: ["adsets", "*adset_id"],
    //         params: { time_range: { since: "2021-12-01", until: "2021-12-01" } },
    //         ads: {
    //             path: ["adsets", "*adset_id", "ads", "*ad_id"],
    //             params: { time_range: { since: "2021-12-01", until: "2021-12-01" } },
    //         },
    //     },
    // },
    // campaigns: {
    //     path: ["campaigns", "*campaign_id"],
    //     params: {
    //         time_range: { since: "2021-12-01", until: "2021-12-01" },
    //         effective_status: ["ACTIVE"],
    //     },
    //     campaign: {
    //         path: ["campaigns", "*campaign_id"],
    //         params: { time_range: { since: "2021-12-01", until: "2021-12-01" } },
    //         campaign_insights: {
    //             path: ["campaigns", "*id"],
    //             params: { time_range: { since: "2021-12-01", until: "2021-12-01" } },
    //         },
    //         adsets: {
    //             path: ["campaigns", "*campaign_id", "adsets", "*adset_id"],
    //             params: { time_range: { since: "2021-12-01", until: "2021-12-01" }, effective_status: ["ACTIVE"] },
    //             adset: {
    //                 path: ["campaigns", "*campaign_id", "adsets", "*adset_id"],
    //                 params: { time_range: { since: "2021-12-01", until: "2021-12-01" } },
    //             },
    //         },
    //     },
    // },
});
// .then((result) => {
//     console.log(util.inspect(result, false, null, true));
// });

let today_pacific_time = formatInTimeZone(new Date(Date.now()), "America/Los_Angeles", "yyyy-MM-dd");
let today = moment(today_pacific_time, "YYYY-MM-DD").format("YYYY-MM-DD");

Account({ account_id }).post({
    // campaign: {
    //     path: ["campaign", "*campaign_id"],
    //     params: {
    //         time_range: { since: "2021-12-01", until: "2021-12-01" },
    //         campaign_id: "23845154544650006",
    //         action: "start",
    //         status: "ACTIVE",
    //     },
    // },
    // campaign: {
    //     path: ["campaign", "*campaign_id"],
    //     params: {
    //         time_range: { since: "2021-12-01", until: "2021-12-01" },
    //         campaign_id: "23845154544650006",
    //         action: "stop",
    //         status: "PAUSED",
    //     },
    // },
    // campaign: {
    //     path: ["campaign", "*campaign_id"],
    //     params: {
    //         campaign_id: "23848052102840006",
    //         action: "increase_budget",
    //         type: "percent",
    //         value: 10,
    //         spend_cap: 0,
    //     },
    // },
    // campaign: {
    //     path: ["campaign", "*campaign_id"],
    //     params: {
    //         time_range: { since: "2021-12-01", until: "2021-12-01" },
    //         campaign_id: "23845154544650006",
    //         action: "increase_budget",
    //         type: "amount",
    //         value: 80,
    //         spend_cap: 0,
    //     },
    // },
    // campaign: {
    //     path: ["campaign", "*campaign_id"],
    //     params: {
    //         time_range: { since: "2021-12-01", until: "2021-12-01" },
    //         campaign_id: "23845154544650006",
    //         action: "decrease_budget",
    //         type: "percent",
    //         value: 10,
    //         spend_cap: 0,
    //     },
    // },
    // campaign: {
    //     path: ["campaign", "*campaign_id"],
    //     params: {
    //         time_range: { since: "2021-12-01", until: "2021-12-01" },
    //         campaign_id: "23845154544650006",
    //         action: "decrease_budget",
    //         type: "amount",
    //         value: 172,
    //         spend_cap: 0,
    //     },
    // },
    // campaign: {
    //     path: ["campaign", "*campaign_id"],
    //     params: {
    //         time_range: { since: "2021-12-01", until: "2021-12-01" },
    //         campaign_id: "23845154544650006",
    //         action: "set_budget",
    //         type: "amount",
    //         value: 800,
    //         spend_cap: 0,
    //     },
    // },
    // adset: {
    //     path: ["adset", "*adset_id"],
    //     params: {
    //         time_range: { since: "2021-12-01", until: "2021-12-01" },
    //         adset_id: "23845154544710006",
    //         action: "start",
    //         status: "ACTIVE",
    //     },
    // },
    // adset: {
    //     path: ["adset", "*adset_id"],
    //     params: {
    //         time_range: { since: "2021-12-01", until: "2021-12-01" },
    //         adset_id: "23845154544710006",
    //         action: "stop",
    //         status: "PAUSED",
    //     },
    // },
    // adset: {
    //     path: ["adset", "*adset_id"],
    //     params: {
    //         time_range: { since: today, until: today },
    //         adset_id: "23850037532950006",
    //         action: "increase_budget",
    //         type: "percent",
    //         value: 10,
    //     },
    // },
    // adset: {
    //     path: ["adset", "*adset_id"],
    //     params: {
    //         time_range: { since: today, until: today },
    //         adset_id: "23850037532950006",
    //         action: "increase_budget",
    //         type: "amount",
    //         value: 100,
    //     },
    // },
    // adset: {
    //     path: ["adset", "*adset_id"],
    //     params: {
    //         time_range: { since: today, until: today },
    //         adset_id: "23850037532950006",
    //         action: "decrease_budget",
    //         type: "percent",
    //         value: 10,
    //     },
    // },
    // adset: {
    //     path: ["adset", "*adset_id"],
    //     params: {
    //         time_range: { since: today, until: today },
    //         adset_id: "23850037532950006",
    //         action: "decrease_budget",
    //         type: "amount",
    //         value: 6,
    //     },
    // },
    // adset: {
    //     path: ["adset", "*adset_id"],
    //     params: {
    //         time_range: { since: today, until: today },
    //         adset_id: "23850037532950006",
    //         action: "set_budget",
    //         type: "amount",
    //         value: 100,
    //     },
    // },
});

// let user_id = "10208987388877755";

// User({ user_id })
//     .ad_accounts.get()
//     .then((value) => {
//         console.log("value");
//         console.log(value);
//     });

// from(User({ access_token }).profile.get()).subscribe((value) => {
//     console.log("value");
//     console.log(value);
// });

exports.Account = Account;
exports.User = User;
exports.request = request;
